module.exports = __webpack_public_path__ + "img/mobile_btn1.c7599a4d.png";